/**
 * INVENTORY RECEIPTS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getInventoryReceipts,
    getInventoryReceipt,
    printInventoryReceipt,
    createInventoryReceipts,
    updateInventoryReceipts,
    deleteInventoryReceipts,
} from "Modules/supply_chain/purchase_orders/config/api.inventory_receipts";

const state = {
    page: {},
    form: {},
    inventory_receipts: [],
    selectedInventoryReceipt: {
        receipt_id: null,
        company_id: "",
        inventory_receipt_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        inventory_receipt_details: [],
    },
    inventory_receipts_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_inventory_receipts: {
        receipt_id: {
            name: "receipt_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        purchase_order_id: {
            name: "purchase_order_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        part_id: {
            name: "part_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        receipt_date: {
            name: "receipt_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        received_quantity: {
            name: "received_quantity",
            rules: "trim|max_length[11]|integer",
            max_len: "11",
            min_len: "",
            default_value: "",
        },
        received_cost: {
            name: "received_cost",
            rules: "trim|max_length[11]|decimal",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        vendor_id: {
            name: "vendor_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        received_by: {
            name: "received_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    inventory_receipts: (state) => {
        return state.inventory_receipts;
    },
};

// actions
const actions = {
    async fetchInventoryReceipts({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getInventoryReceipts({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageInventoryReceipts", response.data.page);
                }

                commit("setInventoryReceipts", response.data.inventory_receipts);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchInventoryReceipt({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getInventoryReceipt(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedInventoryReceipt", response.data.inventory_receipt);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printInventoryReceipt({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printInventoryReceipt(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveInventoryReceipt({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["receipt_id"] === "undefined" || body["receipt_id"] == null || body["receipt_id"] == "") {
                delete body["receipt_id"];
                response = await createInventoryReceipts({ body: body, headers: config.headers });
            } else {
                let receipt_id = body["receipt_id"];
                delete body["receipt_id"];
                response = await updateInventoryReceipts({ body: body, headers: config.headers }, receipt_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteInventoryReceipt({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteInventoryReceipts(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageInventoryReceipts(state, page) {
        state.page = page;
    },
    setInventoryReceipts(state, inventory_receipts) {
        state.inventory_receipts = inventory_receipts;
    },
    setSelectedInventoryReceipt(state, inventory_receipt) {
        state.selectedInventoryReceipt = inventory_receipt;
    },
    resetSelectedInventoryReceipt(state) {
        for (const key in state.selectedInventoryReceipt) {
            if (key in state.rules_inventory_receipts) {
                state.selectedInventoryReceipt[key] =
                    state.rules_inventory_receipts[key].default_value == "null" ? null : state.rules_inventory_receipts[key].default_value;
            }
        }
    },
    resetInventoryReceipts(state) {
        state.page = {};
        state.form = {};
        state.inventory_receipts = [];
        state.selectedInventoryReceipt = {
            receipt_id: null,
            company_id: "",
            inventory_receipt_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            inventory_receipt_details: [],
        };
        state.inventory_receipts_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
